import { useMatch } from 'react-router-dom'
import { basePaths } from 'paths'

export default function useIsClientPage() {
  const isClientPage = useMatch(`${basePaths.client_panel}/*`)

  return isClientPage !== null
}
